import { useEffect } from 'react';
import DataTable from 'react-data-table-component';
import type { TableProps } from 'react-data-table-component';
import { getFormatDDMMYYYY } from '../../../config/utils/dateFunctions';
type PaginationChangeRowsPerPage = NonNullable<TableProps<any>['onChangeRowsPerPage']>;

interface ReportDataProps {
    reportData: any
    handlePageChange: PaginationChangeRowsPerPage | undefined
    handlePerRowsChange: PaginationChangeRowsPerPage | undefined
}

const EnquiryReportDataTable: React.FC<ReportDataProps> = ({ reportData, handlePageChange, handlePerRowsChange }): any => {

    //Custom Style for the data table
    const customStyles = {
        headCells: {
            style: {
                fontSize: "15px",
                fontWeight: "700"
            },
        },
    };

    const SALE_LEADS = [
        { keyName: 10, name: "Sell" },
        { keyName: 20, name: "Buy" },
        { keyName: 30, name: "Finance" },
        { keyName: 40, name: "Premium Park & Sell" },
    ];

    const getSalesNamebyId = (keyName: number) => {
        const sale = SALE_LEADS.find((sale) => sale.keyName === keyName);
        return sale ? sale.name : "";
    };

    //Column Declaraion for the data table
    const columns: any = [
        {
            name: <div>Serial No.</div>,
            wrap: true,
            selector: (row: any, index: number) => index + 1,
            sortable: false,
            width: "10%",  // Adjust width as needed
        },
        {
            name: <div>Model Name</div>,
            wrap: true,
            sortable: true,
            keyName: 'name',
            width: "15%",
            selector: (row: { name: string }) => row.name,
        },
        {
            name: <div>Count</div>,
            wrap: true,
            sortable: true,
            width: "8%",
            selector: (row: { userCount: string; }) => row.userCount,

        },
        {
            name: <div>Client Name</div>,
            wrap: true,
            sortable: true,
            width: "15%",
            selector: (row: { contactName: string; }) => row.contactName,

        },
        {
            name: <div>Client Email</div>,
            wrap: true,
            sortable: true,
            width: "20%",
            selector: (row: { contactEmail: string; }) => row.contactEmail,

        },
        {
            name: <div>Enquiry Date</div>,
            wrap: true,
            sortable: true,
            width: "15%",
            selector: (row: { enquiryDate: string; }) => row.enquiryDate?getFormatDDMMYYYY(row.enquiryDate):"",

        },
        {
            name: <div>Sale Status</div>,
            wrap: true,
            sortable: true,
            width: "15%",
            selector: (row: { saleStatus: string; }) => row.saleStatus ? getSalesNamebyId(Number(row.saleStatus)) : "",

        },

    ];

    useEffect(()=>{
        console.log(reportData.rows)
    }, [reportData])

    return (<>
        <br></br>
        <DataTable
            columns={columns}
            data={reportData.rows}
            striped={true}
            pagination
            paginationServer
            paginationTotalRows={reportData.count}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            highlightOnHover={true}
            customStyles={customStyles}
        />

    </>)

}
export default EnquiryReportDataTable